import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AlertTitle, Box, Button, Container, Stack } from '@mui/material'
import reindrift from '../../assets/reindrift.svg'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import IosShareIcon from '@mui/icons-material/IosShare'
import { useInnsynContext } from '../../context/InnsynContextProvider'
import { MoreVert } from '@mui/icons-material'
import { INNSYN_SEARCH_PATH } from '../../paths'
import { logIn } from '../../services/LoginService'
import { FormattedMessage } from 'react-intl'
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop'

export const Home = () => {
    const [appIsInstalled, setAppIsInstalled] = useState<boolean | undefined>(undefined)
    const navigate = useNavigate()
    const { createAlert, clearAlert, brukerInformasjon, konfigurasjon } = useInnsynContext()

    const alertMessageType = {
        ANDROID_S: 'android_samsung',
        ANDROID_FC: 'android_firefox_chrome',
        APPLE: 'apple',
        MAC: 'mac',
        WINDOWS: 'windows',
        PHONE_NO_PWA: 'phone_no_pwa'
    }

    useEffect(() => {
        setInitialInstallStatus()
    }, [])

    const setInitialInstallStatus = async () => {
        const useExperimentalFeature = false
        // Read more about this experimental API here: https://chromestatus.com/feature/5695378309513216
        // When accepted, this API should be used instead of window.matchMedia() hack.
        if (useExperimentalFeature && 'getInstalledRelatedApps' in navigator) {
            navigator
                // Not currently typed in Navigator as of May 31st 2022, so will be ignored.
                // @ts-ignore
                .getInstalledRelatedApps()
                .then((appArray: string[]) => {
                    if (appArray.length > 0) {
                        setAppIsInstalled(true)
                    } else {
                        setAppIsInstalled(false)
                    }
                })
        } else {
            // @ts-ignore
            if (window.matchMedia('(display-mode: standalone)').matches || navigator?.standalone) {
                setAppIsInstalled(true)
            } else {
                setAppIsInstalled(false)
            }
        }
    }
    const deviceType = () => {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            return 'apple'
        } else if (/Android/i.test(navigator.userAgent)) {
            return 'android'
        } else if (/Macintosh/.test(navigator.userAgent)) {
            return 'mac'
        } else if (/Windows/.test(navigator.userAgent)) {
            return 'windows'
        } else {
            return 'none'
        }
    }

    const alertType = () => {
        if (
            deviceType() === 'apple' &&
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent) &&
            !/CriOS/.test(navigator.userAgent)
        ) {
            return 'apple'
        } else if (
            deviceType() === 'android' &&
            (/Chrome/.test(navigator.userAgent) ||
                /Firefox/.test(navigator.userAgent)) &&
            (parseInt(navigator.userAgent.split('Chrome/')[1]) > 57 ||
                parseInt(navigator.userAgent.split('Firefox/')[1]) > 57) &&
            !/SamsungBrowser/.test(navigator.userAgent)
        ) {
            return 'android_firefox_chrome'
        } else if (
            deviceType() === 'android' &&
            /SamsungBrowser/.test(navigator.userAgent)
        ) {
            return 'android_samsung'
        } else if (deviceType() === 'android' || deviceType() === 'apple') {
            return 'phone_no_pwa'
        } else if (
            /Macintosh/.test(navigator.userAgent) &&
            /Chrome/.test(navigator.userAgent)
        ) {
            return 'mac'
        } else if (
            /Windows/.test(navigator.userAgent) &&
            /Chrome/.test(navigator.userAgent) && //denne kommer også på xbox heheh
            !(/Opera/.test(navigator.userAgent) ||
                /OPR/.test(navigator.userAgent) ||
                /Edg/.test(navigator.userAgent))
        ) {
            return 'windows'
        } else return 'none'
    }

    useEffect(() => {
        if (appIsInstalled === undefined || appIsInstalled) {
            return
        }
        const alertToShow = alertType();
        if (
            !appIsInstalled &&
            (alertToShow === alertMessageType.APPLE ||
                alertToShow === alertMessageType.ANDROID_FC ||
                alertToShow === alertMessageType.ANDROID_S ||
                alertToShow === alertMessageType.MAC ||
                alertToShow === alertMessageType.WINDOWS ||
                alertToShow === alertMessageType.PHONE_NO_PWA)
        ) {
            createAlert({
                body: (
                    <>
                        {alertToShow === alertMessageType.PHONE_NO_PWA ||
                        alertToShow === alertMessageType.MAC ||
                        alertToShow === alertMessageType.WINDOWS ? (
                            <AlertTitle>
                                <FormattedMessage
                                    id={'feilmelding.unsupported-device'}
                                />
                            </AlertTitle>
                        ) : alertToShow === alertMessageType.APPLE ? (
                            <AlertTitle>
                                <FormattedMessage
                                    id={'alert.download.title-apple'}
                                />
                            </AlertTitle>
                        ) : (
                            <AlertTitle>
                                <FormattedMessage id={'alert.download.title'}/>
                            </AlertTitle>
                        )}
                        {(alertToShow === alertMessageType.ANDROID_S ||
                            alertToShow === alertMessageType.ANDROID_FC ||
                            alertToShow === alertMessageType.APPLE) && (
                            <FormattedMessage id={'alert.download.text'}/>
                        )}
                        {alertToShow === alertMessageType.APPLE && (
                            <>
                                <IosShareIcon
                                    sx={{
                                        fontSize: '1.125rem',
                                        marginBottom: '-4px'
                                    }}
                                />{' '}
                            </>
                        )}
                        {alertToShow === alertMessageType.ANDROID_FC && (
                            <>
                                <MoreVert
                                    sx={{
                                        fontSize: '1.125rem',
                                        marginBottom: '-4px'
                                    }}
                                />{' '}
                            </>
                        )}
                        {alertToShow === alertMessageType.ANDROID_S && (
                            <>
                                <Box
                                    sx={{
                                        fontWeight: '600',
                                        display: 'inline'
                                    }}>
                                    +
                                </Box>{' '}
                            </>
                        )}
                        {alertToShow === alertMessageType.APPLE && (
                            <>
                                <FormattedMessage id={'alert.download.text2'}/>
                                <strong>
                                    <FormattedMessage
                                        id={'alert.download.text3-apple'}
                                    />
                                </strong>
                            </>
                        )}
                        {(alertToShow === alertMessageType.ANDROID_S ||
                            alertToShow === alertMessageType.ANDROID_FC) && (
                            <>
                                <FormattedMessage id={'alert.download.text2'}/>
                                <strong>
                                    <FormattedMessage
                                        id={'alert.download.text3'}
                                    />
                                </strong>
                            </>
                        )}
                        {(alertToShow === alertMessageType.MAC ||
                            alertToShow === alertMessageType.WINDOWS) && (
                            <>
                                <FormattedMessage
                                    id='feilmelding.unsupported-device-content-pc'
                                    values={{
                                        icon: (
                                            <InstallDesktopIcon
                                                sx={{
                                                    fontSize: '1.125rem',
                                                    marginBottom: '-4px'
                                                }}
                                            />
                                        )
                                    }}
                                />{' '}
                            </>
                        )}
                        {alertToShow === alertMessageType.PHONE_NO_PWA && (
                            <FormattedMessage id='feilmelding.unsupported-device-content'/>
                        )}
                    </>
                ),
                severity: 'info',
                uniqueId: 'download-info'
            })
        }
        return () => {
            clearAlert('download-info')
        }
    }, [appIsInstalled])
    return (
        <Container sx={{ height: '100%' }} maxWidth={false}>
            <Stack justifyContent={'space-around'} sx={{ height: '100%' }}>
                <Stack>
                    <link rel={'preload'} href={reindrift} as={'image'}/>
                    <img
                        src={reindrift}
                        alt='reineier'
                        style={{
                            margin: '2rem 0',
                            width: '80%',
                            alignSelf: 'center'
                        }}
                    />
                    <Container
                        sx={{
                            textAlign: 'center',
                            fontSize: '0.875rem',
                            marginBottom: '0.5rem'
                        }}>
                        <FormattedMessage id={'front-page.login.text'}/>
                    </Container>
                </Stack>
                <Stack spacing={'1rem'} mb='1.5rem'>
                    {(!brukerInformasjon?.foedselsnummer && konfigurasjon) && (
                        <Button
                            onClick={() => {
                                if (navigator.onLine) {
                                    logIn(konfigurasjon?.altinnUrl)
                                } else {
                                    createAlert({
                                        body: (
                                            <>
                                                <AlertTitle>
                                                    <FormattedMessage id='log-in.alert-no-internet-header'/>
                                                </AlertTitle>
                                                <FormattedMessage id='log-in.alert-no-internet'/>
                                            </>
                                        ),
                                        severity: 'info',
                                        uniqueId: 'log-in-offline'
                                    })
                                }
                            }}
                            size='large'
                            variant='outlined'
                            sx={{ textAlign: 'left' }}
                            startIcon={<ArrowForwardIcon/>}>
                            <FormattedMessage id={'front-page.login'}/>
                        </Button>
                    )}
                    <Button
                        onClick={() => navigate(INNSYN_SEARCH_PATH)}
                        sx={{
                            textAlign: 'left',
                            marginBottom: '15%'
                        }}
                        size='large'
                        variant='outlined'
                        startIcon={<ArrowForwardIcon/>}>
                        <FormattedMessage
                            id={
                                brukerInformasjon?.foedselsnummer
                                    ? 'front-page.proceed'
                                    : 'front-page.proceed-without.login'
                            }
                        />
                    </Button>
                </Stack>
            </Stack>
        </Container>
    )
}

export default Home
